import { Fragment, useCallback, useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";

import UserProfilePopUp from "../UserProfilePopUp";
import { useStyles } from "./styles";
import { GlobalRoutes } from "../../../GlobalRouter/Routes";
import { useSelector } from "react-redux";
import { userRoles } from "../../../Utils/user";
import FAQLink from "../FAQLink";

const LoggedInActions = ({ classes, headerType }) => {
    const [showProfilePopup, setShowProfilePopup] = useState(false);
    const location = useLocation();
    const orgName = useSelector((state) => state.organization.name);
    const orgOwnerEmail = useSelector((state) => state.organization.owner);
    const userEmail = useSelector((state) => state.user.email);

    const handleProfileIconClick = () => {
        setShowProfilePopup(!showProfilePopup);
    };

    const userRole = useCallback(
        () => (orgOwnerEmail === userEmail ? userRoles.OWNER : userRoles.MEMBER),
        [orgOwnerEmail, userEmail]
    );

    const isItServiceCreationPage = location.pathname.includes(
        location.pathname.match(GlobalRoutes.AI_SERVICE_CREATION.match)
    );

    return (
        <div className={classes.loggedActionsContainer}>
            <FAQLink />
            <div className={classes.userProfileContainer} onClick={handleProfileIconClick}>
                <AccountCircleIcon fontSize="large" className={classes.AccountCircleIcon} />
                <UserProfilePopUp
                    show={showProfilePopup}
                    handleClose={() => setShowProfilePopup(false)}
                    headerType={headerType}
                />
                <div className={classes.orgNameContainer}>
                    {isItServiceCreationPage ? (
                        <Typography className={classes.orgName}>{orgName}</Typography>
                    ) : (
                        <Fragment>
                            <Typography className={classes.orgName}>{userEmail}</Typography>
                            <Typography className={classes.role}>{userRole()}</Typography>
                        </Fragment>
                    )}
                </div>
            </div>
        </div>
    );
};

export default withStyles(useStyles)(LoggedInActions);
